import type { VariantProp } from '../../common/colors';

export type LegacyControlVariant = 'primary' | 'secondary' | 'destructive';

export type ControlVariantInput = VariantProp | LegacyControlVariant;

export function normalizeControlVariant(variant?: ControlVariantInput): VariantProp {
  if (variant === 'primary') return 'brand';
  if (variant === 'secondary') return 'neutral';
  if (variant === 'destructive') return 'negative';
  return variant ?? 'brand';
}
